import React from "react";
import { useDispatch, useSelector } from "react-redux";
import SweetAlert from "../components/SweetAlert.jsx";
import LoginPage from "./LoginPage.jsx";
import useLoggedInUser from "../hooks/useLoggedInUser.js";
import { closeLoginPopup } from "../../redux/actions/login.js";


export default function LoginPagePopup() {
	const dispatch = useDispatch();

	const showingLoginPopup = useSelector((state) => state.login.showingLoginPopup);
	const justSignedIn = useSelector((state) => state.login.justSignedIn);
	const justCreatedAccount = useSelector((state) => state.login.justCreatedAccount);
	const player = useLoggedInUser();
	let showAnotherPopup = null;

	function closePopup() {
		dispatch(closeLoginPopup());
	}

	if(justSignedIn) {
		showAnotherPopup = (
			<SweetAlert
				icon='success'
			>
				<div>You are now logged in as {player.email}!</div>
			</SweetAlert>
		);
	} else if(justCreatedAccount) {
		showAnotherPopup = (
			<SweetAlert
				icon='success'
			>
				<div>Your account with email {player.email} has been created!</div>
			</SweetAlert>
		);
	}
	const isOpen = showingLoginPopup && !showAnotherPopup;

	return (
		<React.Fragment>
			{!!showAnotherPopup &&
			showAnotherPopup
			}
			<SweetAlert
				onCancel={closePopup}
				isOpen={isOpen}
				showConfirmButton={false}
				showCancelButton={false}
			>
				<LoginPage />
			</SweetAlert>
		</React.Fragment>
	);
}